import React from 'react';
import { Home, Wrench, RefreshCw, ShieldCheck, ArrowRight } from 'lucide-react';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from './ui/card';
import { Button } from './ui/button';
import { Link } from 'react-router-dom';
import { services } from '../mockData';

const iconMap = {
  'home': Home,
  'wrench': Wrench,
  'refresh-cw': RefreshCw,
  'shield-check': ShieldCheck
};

// Map service IDs to their dedicated page URLs
const serviceLinks = {
  1: '/services/metal-roof-installation',
  2: '/services/roof-repairs',
  3: '/services/roof-replacement',
  4: '/services/gutter-installation'
};

export const ServicesSection = () => {
  return (
    <section id="services" className="section-padding bg-white" data-testid="services-section">
      <div className="container mx-auto px-4">
        <div className="text-center max-w-3xl mx-auto mb-12">
          <h2 className="text-3xl sm:text-4xl md:text-5xl font-bold text-gray-900 mb-4">
            Our <span className="text-primary">Services</span>
          </h2>
          <p className="text-lg text-gray-600">
            Professional metal roofing solutions for residential properties across Greater Sydney
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {services.map((service, index) => {
            const IconComponent = iconMap[service.icon];
            const serviceLink = serviceLinks[service.id] || '/book-inspection';
            return (
              <Card
                key={service.id}
                className="card-hover border-none shadow-lg bg-gray-50 flex flex-col"
                data-testid={`service-card-${service.id}`}
              >
                <CardHeader>
                  <div className="w-14 h-14 bg-primary/10 rounded-lg flex items-center justify-center mb-4">
                    <IconComponent className="w-7 h-7 text-primary" />
                  </div>
                  <CardTitle className="text-xl font-bold text-gray-900">
                    {service.title}
                  </CardTitle>
                </CardHeader>
                <CardContent className="flex-1 flex flex-col">
                  <CardDescription className="text-gray-600 text-base mb-4 flex-1">
                    {service.description}
                  </CardDescription>
                  <Link to={serviceLink}>
                    <Button 
                      variant="outline" 
                      className="w-full border-primary text-primary hover:bg-primary hover:text-white"
                      data-testid={`service-cta-${service.id}`}
                    >
                      View Our Work
                      <ArrowRight className="w-4 h-4 ml-2" />
                    </Button>
                  </Link>
                </CardContent>
              </Card>
            );
          })}
        </div>
      </div>
    </section>
  );
};
